module.exports = __webpack_public_path__ + "img/Easy-Accessible-Efficient.9d4232c.png";